module.exports = __webpack_public_path__ + "img/admin.87c1df82.png";